import React from "react";
import { Button } from "@mui/material";

// Shared action button.
// Positive/primary actions (Add, Update, Save, Continue, Yes...) -> green.
// Negative actions (Cancel, No, Close, Delete, Remove, Discard...) -> red.
// Contained (filled) by default; on hover it switches to an outlined look.
const NEGATIVE_WORDS = ["cancel", "close", "delete", "remove", "discard", "reject", "deny", "clear"];

const CustomButton = ({ val, size, borderColor, handleClick, mainColor, subColor, style, height, mrt, width, startIcon, mrtmd }) => {
  const label = String(val || "").toLowerCase().trim();
  const isNegative = label === "no" || NEGATIVE_WORDS.some((w) => label.includes(w));
  const base = isNegative ? "#EB5757" : "#27AE60";
  const hoverText = isNegative ? "#EB5757" : "#1E8449";

  return (
    <Button
      size={size}
      sx={{
        backgroundColor: base,
        border: `1px solid ${base}`,
        textTransform: "capitalize",
        width: width || "auto", // Apply width from props
        color: "#fff",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "#fff",
          color: hoverText,
          border: `1px solid ${base}`,
          boxShadow: "none",
        },
        mt: { xs: mrtmd || "20px", xs: mrt, lg: "0", md: mrtmd || "0px" },
      }}
      variant={"contained"}
      onClick={handleClick}
      style={style}
      startIcon={startIcon}
      height={height}
      width={width}
    >
      {val}
    </Button>
  );
};

export default CustomButton;
